import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Container, Content } from './styles';

export default function Home({ team }) {
  const authMaintanance = team === 'GERENCIA' || team === 'OFICINA' || team === 'FILIAL';
  const authFinancial = team === 'GERENCIA' || team === 'FINANCIA';
  const authRefuel =
    team === 'GERENCIA' || team === 'ABASTECIMENTO' || team === 'OFICINA' || team === 'FILIAL';
  const authService = team === 'GERENCIA' || team === 'OFICINA' || team === 'RH' || team === 'FILIAL';
  const authPayment =
    team === 'GERENCIA' || team === 'FINANCIA' || team === 'PAGAMENTO' || team === 'RH';

  const authPieceInventory = team === 'GERENCIA' || team === 'OFICINA' || team === 'FILIAL';

  const authEmployee = team === 'GERENCIA' || team === 'OFICINA' || team === 'RH' || team === 'FILIAL';

  const authTechnicalReport = team === 'GERENCIA' || team === 'OFICINA' || team === 'FILIAL';
  const authEquipment = team === 'GERENCIA' || team === 'OFICINA' || team === 'FILIAL';
  const authRegisters = team === 'CADASTROS';

  return (
    <Container>
      <Content>
        <ul>
          {authMaintanance && (
            <li>
              <Link to="/maintenances">MANUTENÇÕES</Link>
            </li>
          )}
          {authMaintanance && (
            <li>
              <Link to="/maintenanceplans">PLANOS DE MANUTENÇÃO</Link>
            </li>
          )}
          {authRefuel && (
            <li>
              <Link to="/refuels">ABASTECIMENTOS</Link>
            </li>
          )}
          {authFinancial && (
            <li>
              <Link to="/financials">FINANÇAS</Link>
            </li>
          )}
          {authService && (
            <li>
              <Link to="/services">SERVIÇOS DE VEÍCULOS</Link>
            </li>
          )}
          {authPayment && (
            <li>
              <Link to="/payments">PAGAMENTO FUNCIONÁRIOS</Link>
            </li>
          )}

          {authPieceInventory && (
            <li>
              <Link to="/inventories">ESTOQUE DE PEÇAS</Link>
            </li>
          )}
          {(authEmployee || authRegisters) && (
            <li>
              <Link to="/employees">FUNCIONÁRIOS</Link>
            </li>
          )}
          {authTechnicalReport && (
            <li>
              <Link to="/technicalreports">RELATÓRIOS TÉCNICOS</Link>
            </li>
          )}
          {(authEquipment || authRegisters) && (
            <li>
              <Link to="/equipments">VEÍCULOS</Link>
            </li>
          )}
        </ul>
      </Content>
    </Container>
  );
}

Home.propTypes = {
  team: PropTypes.string.isRequired,
};
